import React, {Component} from 'react'; 
// import "./css/style.css"; 
import Villagers from './villagers.json';
import firebase from 'firebase/app';
import 'firebase/database';



// These are resources we looked over to create this React page
// https://stackoverflow.com/questions/58257648/how-do-i-display-text-on-button-click-in-react-js
// https://github.com/fedosejev/radio-buttons-react/blob/master/source/js/components/Application.jsx
// test


// Creates entire quiz page including questions and filtering
class Quiz extends Component {
	constructor(props) {
	  super(props);
	 
	  this.state = {noNewCharacter: false, firstButtonName: '', secondButtonName: '', thirdButtonName: '', selectedOption1: '', 
	                selectedOption2: '', selectedOption3: '', showMessage: false, character: '', characterImg: ''};
	  this.handleSubmit1 = this.handleSubmit1.bind(this);
	  this.handleSubmit2 = this.handleSubmit2.bind(this);
	  this.handleSubmit3 = this.handleSubmit3.bind(this);
	}

	// Filters the inputs given by the user to return a villager 
	filterVillagers(selectedOptionVariable, selectedOptionVariable2, selectedOptionVariable3, list) {
		const birthdayString = JSON.parse(selectedOptionVariable2);
		const milkString = JSON.parse(selectedOptionVariable3);
		return list
			.filter(villagerObj => {
		    	if (villagerObj.personality.includes(selectedOptionVariable) && villagerObj.birthday === (birthdayString) && villagerObj.milk === (milkString)) {
					return true;				
		      	} else {
					return false; // alert
			  	} 
		  	})
	}
	
	// Stores the input value of question one
	handleSubmit1(event) {
	  event.preventDefault();
	}

	// Takes in the input of question one and puts in a variable inside the state
	handleInput1(e, buttonName) {
		this.setState({
			selectedOption1: e.target.value,
			firstButtonName: buttonName,
		});
	}

	// Stores the input value of question two
	handleSubmit2(event) {
		event.preventDefault();
	}

	// Takes in the input of question two and puts in a variable inside the state
	handleInput2(e, buttonName) {
    if (this.state.selectedOption1 === '') {
		window.alert("Please pick an answer for question one.");
    } else {
		this.setState({
			selectedOption2: e.target.value,
        	secondButtonName: buttonName,
      	});
    }
	}

	// Stores the input value of question three and randomnly selects a villager based on the three inputs given by the user 

	handleSubmit3(event) {
		event.preventDefault();
		if (!this.state.noNewCharacter) {
			const filteredArray = this.filterVillagers(this.state.selectedOption1, this.state.selectedOption2, this.state.selectedOption3, Villagers);
			const randomNumber = Math.floor(Math.random() * (filteredArray.length - 0) ) + 0;
			const characterObj = filteredArray[randomNumber];
			const characterName = characterObj.villager;
			const characterImage = characterObj.img;
			this.setState({character: characterName, characterImg: characterImage});
			var user = firebase.auth().currentUser;
			if (user === null) {
				window.alert("Please create an account or sign in if you'd like to save your quiz results")
			} else {
				var uid=user.uid;
				var firebaseCharacter = firebase.database().ref('users').child(uid);
				firebaseCharacter.update({
				  "characterName": characterName,
				  "characterImage": characterImage		  
				});
			}
		}
	}
  
	// Takes in the input of question three and puts in a variable inside the state
	handleInput3(e, buttonName) {
    if (this.state.selectedOption1 === '') {
      window.alert("Please pick an answer for question one.");
    } else if (this.state.selectedOption2 === '') {
	  window.alert("Please pick an answer for question two");
	} else if (this.state.selectedOption1 !== '' && this.state.selectedOption2 !== '' && this.state.selectedOption3 !== '') {
		window.alert("Please click play again");
		this.setState({
			noNewCharacter: true
		})

    } else {
      this.setState({
        selectedOption3: e.target.value,
        thirdButtonName: buttonName,
        showMessage: true

      });
    }
  }
	
	playAgain = () => { 
		this.setState({noNewCharacter: false, firstButtonName: '', secondButtonName: '', thirdButtonName: '', selectedOption1: '', 
					   selectedOption2: '', selectedOption3: '', showMessage: false, character: '', characterImg: ''}); 
	  }; 

	render() {
	  return (	
		// Displays the quiz questions, what the user selects, and the resulting character
        <div className="quizPage">
		
		<div className="backlayer">
			<div className="bubble-dots">
				<h1 className="quizTitle">Which Villager Are You Most Like?</h1>
			</div>
		</div>
		<br></br>
		<br></br>

            <form className="firstForm" onSubmit={this.handleSubmit1}>
				<div className="bubble-dots">
					<label className="questionHeading">Q1: You've just woken up and it's your first day on the island! What's the first thing you'd like to do?</label>
				</div>
			  	{this.state.firstButtonName && 
				<div className="helpBubble">
					  <p className="helpText">You selected: <b>{this.state.firstButtonName}</b> </p>
				</div>}
				<div className="buttonContainer">
					<button className="first" aria-label="Check the mail" value="Normal" onClick={e => this.handleInput1(e, "Check the mail")}>Check the mail</button>
					<button className="first" aria-label="Go back to sleep" value="Lazy" onClick={e => this.handleInput1(e, "Go back to sleep")}>Go back to sleep</button>
					<button className="first" aria-label="Fishing" value="Jock" onClick={e => this.handleInput1(e, "Fishing")}>Fishing</button>
					<button className="first" aria-label="Say hello to friends" value="Peppy" onClick={e => this.handleInput1(e, "Say hello to neighbors")}>Say "hello" to neighbors</button>
					<button className="first" aria-label="Bring a gift to your friends" value="Sisterly" onClick={e => this.handleInput1(e, "Bring a gift to your friends")}>Bring a gift to your friends</button>
					<button className="first" aria-label="Grudgingly brush your teeth" value="Cranky" onClick={e => this.handleInput1(e, "Grudgingly brush your teeth")}>Grudgingly brush your teeth</button>
					<button className="first" aria-label="Compare your outfit with other villagers" value="Smug" onClick={e => this.handleInput1(e, "Compare your outfit with other villagers")}>Compare your outfit with other villagers</button>
					<button className="first" aria-label="Try to leave your island" value="Snooty" onClick={e => this.handleInput1(e, "Try to leave your island")}>Try to leave your island</button>
				</div>
			</form>

			<br></br>

			<form className="secondForm" onSubmit={this.handleSubmit2}>
			<div className="bubble-dots">
				<label className="questionHeading">Q2: Which season is your birthday in?</label>
			</div>
			{this.state.secondButtonName && 
				<div className="helpBubble">
					<p className="helpText">You have selected: <b>{this.state.secondButtonName}</b> </p>
				</div>}
				<div className="buttonContainer">
					<button className="second" aria-label="Winter" value="1" onClick={e => this.handleInput2(e, "Winter")}>Winter</button>
					<button className="second" aria-label="Spring" value="2" onClick={e => this.handleInput2(e, "Spring")}>Spring</button>
					<button className="second" aria-label="Summer" value="3" onClick={e => this.handleInput2(e, "Summer")}>Summer</button>
					<button className="second" aria-label="Autumn" value="4" onClick={e => this.handleInput2(e, "Autumn")}>Autumn</button>
				</div>
			</form>

			<br></br>
			
			<form className="thirdForm" onSubmit={this.handleSubmit3}>
			<div className="bubble-dots">
				<label className="questionHeading">Q3: You're at Brewster's Cafe! How much milk are you going to add in your coffee?</label>
			</div>
			{this.state.thirdButtonName && 
			<div className="helpBubble">
				<p className="helpText">You have selected: <b>{this.state.thirdButtonName}</b> </p>
			</div>}
			<div className="buttonContainer">
				<button className="third" aria-label="None"  value="0" onClick={e => this.handleInput3(e, "None")}>None</button>
				<button className="third" aria-label="Litte/Regular Amount" value="1" onClick={e => this.handleInput3(e, "Little/Regular Amount")}>Little/Regular Amount</button>
				<button className="third" aria-label="Lots" value="2" onClick={e => this.handleInput3(e, "Lots")}>Lots</button>
			</div>
			</form>	

			{this.state.showMessage && 
			<div>
				<div className="confetti">&nbsp;</div>


				<div className="resultsContainer">
					<div className="bubble-dots">
						<h3 className="quizTitle">You got {this.state.character} !</h3> 
					</div>
					<br></br>
					<div className="bubble-dots">
						<img className="characterResult" alt={this.state.character} src={this.state.characterImg} ></img>
					</div>
					<br></br>
					<br></br>
					<button className="playAgain" aria-label="Play Again"onClick={e => this.playAgain()}>Play Again</button>
				</div>
			</div>}

        </div>
	  );
	}
}

export default Quiz;

export {Quiz};